import React, { useState } from 'react';

export default function SetField({ value, onChange, mode, config, ...props }) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    if (mode === "view") {
        const displayValue = Array.isArray(value) ? JSON.stringify(value, null, 2) : value;
        return (
            <div>
                <span className="text-muted">Set</span>
                {value && (
                    <button 
                        type="button" 
                        className="btn btn-sm btn-outline-secondary ms-2"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? "Collapse" : "Expand"}
                    </button>
                )}
                {isExpanded && (
                    <pre className="mt-2 p-2 bg-light border rounded">
                        {displayValue}
                    </pre>
                )}
            </div>
        );
    }
    
    return (
        <textarea 
            value={Array.isArray(value) ? JSON.stringify(value, null, 2) : (value || "")} 
            onChange={e => {
                try {
                    const parsed = JSON.parse(e.target.value);
                    onChange(parsed);
                } catch (error) {
                    onChange(e.target.value);
                }
            }} 
            className="form-control"
            placeholder="Enter JSON array for set"
            rows={5}
            {...props}
        />
    );
} 